// extracted by mini-css-extract-plugin
export default {"container":"CustomerRatings_container__pfCRB","Rate":"CustomerRatings_Rate__LDX6W"};